import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage, PaymentMethodRetrieve, PaymentMethodUpdate } from 'types';
import { client } from 'utils/api-client';

export default function useUpdatePaymentMethod(): UseMutationResult<
  AxiosResponse<PaymentMethodRetrieve>,
  AxiosError<ErrorMessage>,
  PaymentMethodUpdate
> {
  const queryClient = useQueryClient();

  const updatePaymentMethod = (payload: PaymentMethodUpdate): Promise<AxiosResponse<any>> => {
    return client.put(`payment-methods/${payload.paymentMethodId}/`, payload);
  };

  return useMutation(updatePaymentMethod, {
    onSuccess: () => {
      queryClient.invalidateQueries('paymentMethods');
    },
  });
}
